"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var findMediaObject = function findMediaObject(media, identifier) {
  if (!media || !identifier) return {}; // search parent object

  if (media.formatIdentifier === identifier) {
    return media;
  } // search subFormats


  if (media !== null && media !== void 0 && media.subFormats && (media === null || media === void 0 ? void 0 : media.subFormats.length) > 0) {
    var found = media === null || media === void 0 ? void 0 : media.subFormats.find(function (item) {
      return item.formatIdentifier === identifier;
    });

    if (found) {
      return found;
    }
  }
};

var _default = findMediaObject;
exports.default = _default;